<template>
    <ProgressBar :class="{'is-visible': product.isLoading}"></ProgressBar>
    <div class="ProductList ProductList--col3" v-if="product.items" :class="{'is-loading': product.isLoading}">
        <ProductItem v-for="productItem in product.items" :key="productItem.id" :source="productItem.html"></ProductItem>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";

import ProductItem from "./ProductItem.vue";
import ProgressBar from "./../common/ProgressBar.vue";

export default defineComponent({
    name: "ProductList",
    components: {
        ProductItem,
        ProgressBar
    },
    computed: {
        ...mapState(['product'])
    }
});
</script>
